const en_contract = {

}

export default en_contract;